export default __webpack_public_path__ + "static/media/pepsico.76ca1dde.png";